import React from "react";
import { Create, SimpleForm, Toolbar, FormDataConsumer } from "react-admin";
import GameSchoolReferenceInput from "./GameSchoolReferenceInput";
import MuiAlert from "@material-ui/lab/Alert";
import ChangeTeamsSaveButton from "./ChangeTeamsSaveButton";
import _ from "lodash";

const GameCreateToolbar = (props) => {
  return (
    <Toolbar {...props}>
      <ChangeTeamsSaveButton label="Update" redirect="edit" />
    </Toolbar>
  );
};

const WarningMessage = () => {
  return (
    <FormDataConsumer>
      {({ formData, ...rest }) =>
        formData.isChangingTeams && (
          <MuiAlert severity="warning" elevation={6} variant="filled">
            This action will delete any plays, game stats, and/or player stats
            associated with this game.
          </MuiAlert>
        )
      }
    </FormDataConsumer>
  );
};

const ChangeTeamsGameCreate = (props) => {
  const transform = (data) => {
    const locationId = _.get(data, "location.id");
    return {
      ...data,
      ...(locationId && { location: locationId })
    };
  };
  return (
    <Create {...props} transform={transform}>
      <SimpleForm toolbar={<GameCreateToolbar />}>
        <WarningMessage />
        <GameSchoolReferenceInput type="home" />
        <GameSchoolReferenceInput type="away" />
      </SimpleForm>
    </Create>
  );
};

export default ChangeTeamsGameCreate;
